import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	domain__sync: 'mw/admin/domain/sync',
};

export const domainApi = createApi({
	reducerPath: 'mw/admin/domainApi',

	endpoints: (builder) => ({
		domainSync: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/admin/domain/sync?${qs.stringify(body)}`,
			}),
			providesTags: [tags.domain__sync],
		}),
	}),
});

export const {
	domainSync,
} = domainApi.endpoints;

export default domainApi;